export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";